import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import * as aserver from '../../APIClient';
import * as utils from '../../Utilities';
import Toast from "../comps/alertMessage";

const MONTH_NAMES = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    height: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: 'calc(100vh - 56px)',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      overflow: 'visible',
      flex: 'none',
      padding: theme.spacing(1.5),
    },
  },
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1.5),
    flexShrink: 0,
  },
  tabPanel: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      overflow: 'visible',
      flex: 'none',
    },
  },
  costsPanel: {
    overflowY: 'auto',
    padding: '4px 0',
  },
  summaryPanel: {
    padding: '10px 14px',
    marginBottom: theme.spacing(1.5),
    background: '#f5f5f5',
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    gap: theme.spacing(4),
    flexWrap: 'wrap',
    flexShrink: 0,
    '& span': {
      fontSize: '0.9rem',
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      '& span': { fontSize: '0.82rem' },
    },
  },
  twoPane: {
    display: 'flex',
    flex: 1,
    gap: theme.spacing(2),
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      flex: 'none',
      gap: 0,
    },
  },
  leftPane: {
    width: 240,
    flexShrink: 0,
    overflowY: 'auto',
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  monthDropdownWrapper: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      order: 1,
      width: '100%',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.divider}`,
      position: 'relative',
      zIndex: 10,
    },
  },
  monthDropdownTrigger: {
    width: '100%',
    padding: '8px 10px',
    fontSize: '0.9rem',
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
    background: '#fff',
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
    userSelect: 'none',
  },
  monthDropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    background: '#fff',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    maxHeight: 260,
    overflowY: 'auto',
    zIndex: 20,
  },
  monthDropdownBackdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 9,
  },
  monthItem: {
    padding: '8px 10px',
    borderRadius: 4,
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '0.9rem',
    color: theme.palette.text.primary,
    '&:hover': {
      background: theme.palette.action.hover,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '5px 8px',
      fontSize: '0.8rem',
      flexShrink: 0,
    },
  },
  monthItemSelected: {
    background: theme.palette.primary.main,
    color: '#fff !important',
    '& span': {
      color: '#fff !important',
    },
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
  monthItemInner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 6,
    '& span:first-child': {
      color: 'inherit',
    },
  },
  monthBadge: {
    borderRadius: 3,
    padding: '1px 5px',
    fontSize: '0.65rem',
    fontWeight: 700,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
    flexShrink: 0,
  },
  monthBadgePaid:      { background: '#4caf50', color: '#fff' },
  monthBadgeDue:       { background: '#ff7043', color: '#fff' },
  monthBadgeOverdue:   { background: '#c62828', color: '#fff' },
  monthBadgeNoInvoice: { background: '#bdbdbd', color: '#fff' },
  rightPane: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'contents',
    },
  },
  invoiceSection: {
    [theme.breakpoints.down('sm')]: {
      order: 0,
    },
  },
  logSection: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      order: 2,
      flex: 'none',
      overflowX: 'auto',
    },
  },
  rightPaneEmpty: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
    fontSize: '0.95rem',
  },
  invoiceCard: {
    border: '1px solid #ddd',
    borderRadius: 6,
    padding: '14px 16px',
    background: '#fff',
    fontSize: '0.85rem',
  },
  invoiceCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  invoiceCardTitle: {
    fontWeight: 700,
    fontSize: '1rem',
  },
  invoiceBadge: {
    borderRadius: 4,
    padding: '2px 10px',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },
  invoiceBadgePaid: {
    background: '#4caf50',
    color: '#fff',
  },
  invoiceBadgeAuthorised: {
    background: '#ff7043',
    color: '#fff',
  },
  invoiceBadgePending: {
    background: '#bdbdbd',
    color: '#fff',
  },
  invoiceCardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 4,
    color: '#444',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 2,
    },
  },
  invoiceCardRef: {
    marginBottom: 8,
    color: '#444',
  },
  invoiceCardDivider: {
    borderTop: '1px solid #eee',
    margin: '8px 0',
  },
  invoiceCardSectionLabel: {
    fontWeight: 700,
    fontSize: '0.75rem',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: '#888',
    marginBottom: 6,
  },
  invoiceLineItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 3,
    color: '#333',
  },
  invoiceCardTotals: {
    borderTop: '1px solid #eee',
    marginTop: 8,
    paddingTop: 6,
  },
  invoiceCardTotalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 3,
    color: '#555',
  },
  invoiceCardAmountDue: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 700,
    color: '#111',
    marginTop: 4,
  },
  invoiceViewBtn: {
    border: 'none',
    borderRadius: 4,
    padding: '3px 10px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    marginLeft: 8,
    marginRight: 8,
    background: theme.palette.primary.main,
    color: '#fff',
  },
  invoicePayBtn: {
    border: 'none',
    borderRadius: 4,
    padding: '3px 10px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    marginLeft: 8,
    marginRight: 8,
    background: '#de3229',
    color: '#fff',
  },
  invoiceCollapseToggle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    marginBottom: 8,
    '&:hover': { opacity: 0.75 },
  },
  invoiceCreditsNote: {
    marginTop: 10,
    padding: '6px 10px',
    background: '#f0faf0',
    border: '1px solid #c8e6c9',
    borderRadius: 4,
    color: '#2e7d32',
    fontSize: '0.78rem',
  },
  invoiceCardUnavailable: {
    border: '1px dashed #ccc',
    borderRadius: 6,
    padding: '12px 16px',
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.disabled,
    fontSize: '0.85rem',
    maxWidth: 420,
  },
  usageScroll: {
    flex: 1,
    overflowY: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    [theme.breakpoints.down('sm')]: {
      flex: 'none',
      overflowX: 'auto',
    },
  },
  usageTable: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  usageHead: {
    position: 'sticky',
    top: 0,
    background: '#f5f5f5',
    zIndex: 1,
  },
  usageTh: {
    textAlign: 'left',
    padding: '6px 10px',
    borderBottom: '2px solid #ddd',
    whiteSpace: 'nowrap',
  },
  usageThRight: {
    textAlign: 'right',
    padding: '6px 10px',
    borderBottom: '2px solid #ddd',
    whiteSpace: 'nowrap',
  },
  usageTd: {
    textAlign: 'left',
    padding: '0px 5px',
    borderBottom: '1px solid #eee',
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.72rem',
    },
  },
  usageTdDesc: {
    textAlign: 'left',
    padding: '0px 5px',
    borderBottom: '1px solid #eee',
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.72rem',
      padding: '0px 3px',
      maxWidth: 110,
      wordBreak: 'break-word',
      whiteSpace: 'normal',
    },
  },
  usageTdRight: {
    textAlign: 'right',
    padding: '5px 10px',
    borderBottom: '1px solid #eee',
    fontSize: '0.875rem',
  },
  noData: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
}));

// eslint-disable-next-line
class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
      loading: true,
      tokenBalance: 0,
      assessmentsNo: [],
      transactionHistory: [],
      monthlyInvoices: [],
      selectedMonth: null,
      xeroError: null,
      collapsedInvoices: {},
      mobileDropdownOpen: false,
      billingCurrency:""
    };
  }

  fetchData = async () => {
    const coachId = localStorage.getItem("Id");

    // Fire all requests simultaneously
    const coachPromise = aserver.get(`api/v2/coaches/${coachId}`);
    const assessmentsPromise = aserver.get(`api/v2/coaches/${coachId}/tokensX`);
    const historyPromise = aserver.get(`api/v2/coaches/${coachId}/balanceTransactions`);
    const invoicesPromise = aserver.get(`api/v2/coaches/${coachId}/invoices`);

    // Unblock the Costs tab as soon as coach info arrives
    try {
      const result = await coachPromise;
      this.setState({
        productCosts: result.data.productCosts,
        tokenBalance: result.data.tokenBalance,
        billingCurrency:result.data.billingCurrency,
        ...(window.location.hash === '#costs' && { tabValue: 1 }),
      });
    } catch (e) {}

    // Update the Invoices tab once billing data is ready
    try {
      const [assessments, historyRes] = await Promise.all([assessmentsPromise, historyPromise]);
      for (let record of historyRes.data) {
        record._rawDatetime = record.datetime;
        aserver.convertUTCToLocal(record, 'datetime');
      }
      const months = this.allMonths(historyRes.data);
      this.setState({
        assessmentsNo: assessments.data,
        transactionHistory: historyRes.data,
        selectedMonth: months.length > 0 ? months[0] : null,
      });
    } catch (e) {
      this.setState({ loading: false });
      return;
    }

    // Finish loading once invoices arrive
    try {
      let monthlyInvoices = [];
      let xeroDown = false;
      let xeroError = null;
      const invoicesRes = await invoicesPromise;
      if (invoicesRes.status === 200) {
        monthlyInvoices = invoicesRes.data.invoices || [];
        xeroDown = invoicesRes.data.xeroDown;
      } else {
        xeroError = invoicesRes.data?.message || 'Unable to load invoices.';
      }
      this.setState({ loading: false, monthlyInvoices, xeroDown });
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  groupByMonth = (transactions) => {
    const map = {};
    for (const tx of transactions) {
      const key = (tx._rawDatetime || tx.datetime || '').slice(0, 7);
      if (!key || key.length < 7 || key === '-') continue;
      if (!map[key]) map[key] = [];
      map[key].push(tx);
    }
    return map;
  };

  allMonths = (transactions) => {
    const txKeys = new Set(Object.keys(this.groupByMonth(transactions)));
    const invKeys = new Set((this.state.monthlyInvoices || []).map(i => (i.date || '').slice(0, 7)).filter(Boolean));
    const all = new Set([...txKeys, ...invKeys]);
    return Array.from(all).sort((a, b) => b.localeCompare(a));
  };

  monthLabel = (key) => {
    const [year, month] = key.split('-');
    return `${MONTH_NAMES[parseInt(month, 10) - 1]} ${year}`;
  };

  openInvoice = async (xeroInvoiceId) => {
    const res = await aserver.get(`api/v2/coaches/${localStorage.getItem("Id")}/invoiceUrl/${xeroInvoiceId}`);
    if (res.status === 200) {
      window.open(res.data.externalXeroUrl, '_blank', 'noopener,noreferrer');
    } else {
      this.setState({ level: 'error', message: res.data?.message || 'Could not open invoice.', showToast: true });
    }
  };

  toggleInvoice = (invoiceID) => {
    this.setState(prev => ({
      collapsedInvoices: { ...prev.collapsedInvoices, [invoiceID]: !prev.collapsedInvoices[invoiceID] },
    }));
  };

  componentDidMount = () => {
    this.fetchData();
  };

  renderCostsTab() {
    const classes = this.props.classes;
    const { productCosts } = this.state;
    if (!productCosts) {
      return <Typography className={classes.noData}>Loading...</Typography>;
    }
    return (
      <div className={classes.costsPanel}>
        <h4>Credits cost {this.state.billingCurrency !=="ZAR"? `$${productCosts.credits.USD}` : `R${productCosts.credits.ZAR} + VAT for SADC residents`}</h4>
        <h3><b>Assessment cost:</b></h3>
        <li>3 credits for {utils.assessmentCodeToName('full')} Assessment ({utils.assessmentCodeToName('ennea')} + {utils.assessmentCodeToName('EIT')})</li>
        <li>2 credits for {utils.assessmentCodeToName('EIT')} Assessment (IMf)</li>
        <li>1 credit for {utils.assessmentCodeToName('ennea')} Assessment</li>
        <h3><b>Team report cost:</b></h3>
        <li>4 credits for {utils.teamCodeToName('full')} Team Report (Enneagram + Maturity)</li>
        <li>2 credits for {utils.teamCodeToName('EIT')} Team Report</li>
        <li>2 credits for {utils.teamCodeToName('ennea')} Team Report</li>
        <h3><b>Pair report cost:</b></h3>
        <li>2 credits for Enneagram Couples Report</li>
        <li>2 credits for Enneagram Workplace Report</li>
        <h3><b>Self-registration cost:</b></h3>
        <li>Self-registered enneagram assessments cost {this.state.billingCurrency !=="ZAR"? `$${productCosts.selfRegisterAssessments.USD}` : `R${productCosts.selfRegisterAssessments.ZAR} + VAT for SADC residents.`}</li>
        <li>Self-registered pair reports cost {this.state.billingCurrency !=="ZAR"? `$${productCosts.pairSelfRegisterReports.USD}` : `R${productCosts.pairSelfRegisterReports.ZAR} + VAT for SADC residents.`}</li>
        <h4>Read more about self-registration in your user profile, under <a href='/coachportal/profile#webResourcesSection'>Web Resources.</a></h4>
      </div>
    );
  }

  renderInvoicesTab() {
    const classes = this.props.classes;
    const { tokenBalance, assessmentsNo, transactionHistory, selectedMonth, loading } = this.state;

    const txByMonth = this.groupByMonth(transactionHistory);
    const months = this.allMonths(transactionHistory);
    const selectedRows = selectedMonth ? (txByMonth[selectedMonth] || []) : [];
    const selectedLabel = selectedMonth ? this.monthLabel(selectedMonth) : '';

    return (
      <div className={classes.tabPanel}>
        <div className={classes.summaryPanel}>
          <span>{loading ? 'Loading...' : `You have facilitated ${Math.abs(assessmentsNo.length)} assessments.`}</span>
          <span>
            {loading ? 'Loading...' : tokenBalance >= 0
              ? `Current balance: ${tokenBalance} credits`
              : `Current deficit: ${Math.abs(tokenBalance)} credits (you will be invoiced at the end of this month)`}
          </span>
        </div>
        {loading ? (
          <Typography className={classes.noData}>Loading...</Typography>
        ) : months.length === 0 ? (
          <Typography className={classes.noData}>No transaction history available.</Typography>
        ) : (
          <div className={classes.twoPane}>

            {/* Mobile month dropdown */}
            <div className={classes.monthDropdownWrapper}>
              {this.state.mobileDropdownOpen && (
                <div
                  className={classes.monthDropdownBackdrop}
                  onClick={() => this.setState({ mobileDropdownOpen: false })}
                />
              )}
              <div
                className={classes.monthDropdownTrigger}
                onClick={() => this.setState(s => ({ mobileDropdownOpen: !s.mobileDropdownOpen }))}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {selectedMonth && (() => {
                    const invs = this.state.monthlyInvoices.filter(i => (i.date || '').slice(0, 7) === selectedMonth);
                    if (invs.length === 0) return (
                      <>
                        <span>{this.monthLabel(selectedMonth)}</span>
                        <span className={clsx(classes.monthBadge, classes.monthBadgeNoInvoice)}>{this.state.xeroDown?'Invoice N/A':'No Invoice'}</span>
                      </>
                    );
                    return (
                      <>
                        <span>{this.monthLabel(selectedMonth)}</span>
                        {invs.map(i => {
                          const isOverdue = i.status === 'AUTHORISED' && new Date(i.dueDate) < new Date();
                          const badgeCls = i.status === 'PAID' ? classes.monthBadgePaid : isOverdue ? classes.monthBadgeOverdue : classes.monthBadgeDue;
                          const label = i.status === 'PAID' ? 'Paid' : isOverdue ? 'Overdue' : 'Due';
                          return <span key={i.invoiceID} className={clsx(classes.monthBadge, badgeCls)}>{label}</span>;
                        })}
                      </>
                    );
                  })()}
                </span>
                <span style={{ fontSize: '0.75rem', color: '#888' }}>
                  {this.state.mobileDropdownOpen ? '▲' : '▼'}
                </span>
              </div>
              {this.state.mobileDropdownOpen && (
                <div className={classes.monthDropdownList}>
                  {months.map((key) => {
                    const invs = this.state.monthlyInvoices.filter(i => (i.date || '').slice(0, 7) === key);
                    return (
                      <div
                        key={key}
                        className={clsx(classes.monthItem, key === selectedMonth && classes.monthItemSelected)}
                        onClick={() => this.setState({ selectedMonth: key, mobileDropdownOpen: false })}
                      >
                        <div className={classes.monthItemInner}>
                          <span>{this.monthLabel(key)}</span>
                          {invs.length === 0
                            ? <span className={clsx(classes.monthBadge, classes.monthBadgeNoInvoice)}>{this.state.xeroDown?'Invoice N/A':'No Invoice'}</span>
                            : invs.map(i => {
                                const isOverdue = i.status === 'AUTHORISED' && new Date(i.dueDate) < new Date();
                                const badgeCls = i.status === 'PAID' ? classes.monthBadgePaid : isOverdue ? classes.monthBadgeOverdue : classes.monthBadgeDue;
                                const label = i.status === 'PAID' ? 'Paid' : isOverdue ? 'Overdue' : 'Due';
                                return <span key={i.invoiceID} className={clsx(classes.monthBadge, badgeCls)}>{label}</span>;
                              })
                          }
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Left pane — month list (desktop) */}
            <div className={classes.leftPane}>
              {months.map((key) => (
                <div
                  key={key}
                  className={clsx(classes.monthItem, key === selectedMonth && classes.monthItemSelected)}
                  onClick={() => this.setState({ selectedMonth: key })}
                >
                  <div className={classes.monthItemInner}>
                    <span>{this.monthLabel(key)}</span>
                    {(() => {
                      const invs = this.state.monthlyInvoices.filter(i => (i.date || '').slice(0, 7) === key);
                      if (invs.length === 0) return <span className={clsx(classes.monthBadge, classes.monthBadgeNoInvoice)}>{this.state.xeroDown?'Invoice N/A':'No Invoice'}</span>;
                      return invs.map(i => {
                        const isOverdue = i.status === 'AUTHORISED' && new Date(i.dueDate) < new Date();
                        const badgeCls = i.status === 'PAID' ? classes.monthBadgePaid : isOverdue ? classes.monthBadgeOverdue : classes.monthBadgeDue;
                        const label = i.status === 'PAID' ? 'Paid' : isOverdue ? 'Overdue' : 'Due';
                        return <span key={i.invoiceID} className={clsx(classes.monthBadge, badgeCls)}>{label}</span>;
                      });
                    })()}
                  </div>
                </div>
              ))}
            </div>

            {/* Right pane — invoice details + activity log */}
            {selectedMonth ? (
              <div className={classes.rightPane}>

                {/* Invoice cards */}
                <div className={classes.invoiceSection}>
                {(() => {
                  const invs = this.state.monthlyInvoices.filter(i => (i.date || '').slice(0, 7) === selectedMonth);
                  const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
                  const fmtAmt = (n, code) => `${code || 'ZAR'} ${Number(n).toFixed(2)}`;
                  if (invs.length === 0) {
                    return (
                      <div className={classes.invoiceCardUnavailable}>
                        {this.state.xeroError
                          ? 'No billing link found — please let devteam@aephoriagroup.com know, and we can connect you to the invoice feed.'
                          : (this.state.xeroDown?'Invoice data is currently not available - please check back later.':`No invoice issued for ${selectedLabel}`)}
                      </div>
                    );
                  }
                  return invs.map(inv => {
                    const isCollapsed = !!this.state.collapsedInvoices[inv.invoiceID];
                    const badgeClass = inv.status === 'PAID' ? classes.invoiceBadgePaid : inv.status === 'AUTHORISED' ? classes.invoiceBadgeAuthorised : classes.invoiceBadgePending;
                    return (
                      <div key={inv.invoiceID} className={classes.invoiceCard} style={{ marginBottom: 10 }}>
                        <div className={classes.invoiceCollapseToggle} onClick={() => this.toggleInvoice(inv.invoiceID)}>
                          <span>
                            <span className={classes.invoiceCardTitle}>Invoice #{inv.invoiceNumber}</span>
                            {inv.invoiceID && (
                              <button
                                className={inv.status === 'AUTHORISED' ? classes.invoicePayBtn : classes.invoiceViewBtn}
                                onClick={(e) => { e.stopPropagation(); this.openInvoice(inv.invoiceID); }}
                              >
                                {inv.status === 'AUTHORISED' ? 'Pay' : 'View'}
                              </button>
                            )}
                          </span>
                          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span className={clsx(classes.invoiceBadge, badgeClass)}>{inv.status}</span>
                            <span style={{ fontSize: '0.75rem', color: '#888' }}>{isCollapsed ? '▶' : '▼'}</span>
                          </span>
                        </div>
                        {!isCollapsed && (
                          <>
                            <div className={classes.invoiceCardRow}>
                              <span>Date: {fmtDate(inv.date)}</span>
                              <span>Due Date: {fmtDate(inv.dueDate)}</span>
                            </div>
                            {inv.reference && (
                              <div className={classes.invoiceCardRef}>Ref: {inv.reference}</div>
                            )}
                            <div className={classes.invoiceCardDivider} />
                            <div className={classes.invoiceCardSectionLabel}>Line Items</div>
                            {(inv.lineItems || []).map((item, idx) => (
                              <div key={idx} className={classes.invoiceLineItem}>
                                <span>{item.quantity}x {item.description}</span>
                                <span>{fmtAmt(item.lineAmount, inv.currencyCode)}</span>
                              </div>
                            ))}
                            <div className={classes.invoiceCardTotals}>
                              <div className={classes.invoiceCardTotalRow}>
                                <span>Total:</span>
                                <span>{fmtAmt(inv.total, inv.currencyCode)}</span>
                              </div>
                              <div className={classes.invoiceCardAmountDue}>
                                <span>Amount Due:</span>
                                <span>{fmtAmt(inv.amountDue, inv.currencyCode)}</span>
                              </div>
                            </div>
                            {inv.addedCreditsOn && (
                              <div className={classes.invoiceCreditsNote}>
                                Credits added to your balance on {fmtDate(inv.addedCreditsOn)} — see your transaction log for details.
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    );
                  });
                })()}
                </div>

                {/* Activity log */}
                <div className={classes.logSection}>
                {selectedRows.length === 0 ? (
                  <Typography className={classes.noData}>No usage for this month.</Typography>
                ) : (
                  <div className={classes.usageScroll}>
                    <table className={classes.usageTable}>
                      <thead>
                        <tr className={classes.usageHead}>
                          <th className={classes.usageTh}>Date &amp; Time</th>
                          <th className={classes.usageTh}>Description</th>
                          <th className={classes.usageThRight}>Credits</th>
                          <th className={classes.usageThRight}>Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRows.map((tx, i) => (
                          <tr key={i}>
                            <td className={classes.usageTd}>{tx.datetime}</td>
                            <td className={classes.usageTdDesc}>{tx.description}</td>
                            <td className={classes.usageTdRight}>{tx.credits}</td>
                            <td className={classes.usageTdRight}>{tx.balance}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                </div>

              </div>
            ) : (
              <div className={classes.rightPaneEmpty}>Select a month to view details.</div>
            )}

          </div>
        )}
      </div>
    );
  }

  render() {
    const classes = this.props.classes;
    const { tabValue } = this.state;

    return (
      <>
        <div className={classes.root}>
          <CssBaseline />
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
              <Paper className={classes.paper}>
                <Tabs
                  value={tabValue}
                  onChange={(e, v) => this.setState({ tabValue: v })}
                  className={classes.tabsBar}
                >
                  <Tab label="Invoices" />
                  <Tab label="Costs" />
                </Tabs>
                {tabValue === 0 && this.renderInvoicesTab()}
                {tabValue === 1 && this.renderCostsTab()}
              </Paper>
              <Toast
                level={this.state.level}
                message={this.state.message}
                visible={this.state.showToast}
              />
            </Container>
          </main>
        </div>
      </>
    );
  }
}

// eslint-disable-next-line
export default () => {
  const classes = useStyles();
  return <Billing classes={classes} />;
};
